module.exports = __webpack_public_path__ + "static/media/bg-login.b34c3fd7.jpg";